<template>
  <div>
    <!-- <v-btn
        v-if="$admin.can('md-makes.create')"
        color="primary"
        dark
        @click="openModal"
      >
        {{ $t("add_new") }}
      </v-btn> -->
    <!-- v-if="isVisibleDialog" -->
    <v-dialog
      v-model="isVisibleDialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="openModal"
        >
          {{ $t("email_alerts_settings") }}
        </v-btn>
      </template>

      <v-form
        ref="form"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h3">{{ $t("email_alerts_settings") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row class="mt-3">
                <template v-if="authUser.isAdmin">
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-autocomplete
                      v-model="options.product"
                      dense
                      :items="['oem', 'cso']"
                      :label="$t('product_*')"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-autocomplete
                      v-model="options.tenant"
                      dense
                      :loading="tenantLoading"
                      :items="tenantsByProduct"
                      item-value="id"
                      item-text="name"
                      :label="$t('select_tenant_*')"
                      :rules="[rules.required]"
                    />
                  </v-col>
                </template>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="options.name"
                    dense
                    :label="$t('name_*')"
                    :rules="[rules.required]"
                  />
                </v-col>
                <!-- Email -->
                <v-col
                  v-for="(email, index) in emails"
                  :key="index"
                  cols="12"
                  sm="12"
                >
                  <div class="d-flex align-center gap5">
                    <v-text-field
                      v-model="emails[index]"
                      dense
                      :label="$t('email_*')"
                      :rules="[rules.required, rules.email]"
                    />
                    <div>
                      <v-btn
                        v-if="index === emails.length - 1 && index < 4"
                        x-small
                        color="primary"
                        @click="emails.push('')"
                      >
                        <v-icon small>
                          mdi-plus
                        </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="emails.length > 1"
                        x-small
                        color="red"
                        @click="emails.splice(index, 1)"
                      >
                        <v-icon small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <!-- Email -->
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="options.alert_type"
                    dense
                    item-value="id"
                    item-text="name"
                    :items="alertTypeOpt"
                    :label="$t('alert_type_*')"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  v-if="options.alert_type == 'charger_error'"
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="options.trigger_after_seconds"
                    dense
                    item-value="id"
                    item-text="name"
                    :items="durationLists"
                    :label="$t('duration_*')"
                    :rules="[rules.required]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <small>{{ $t("indicates_required_field") }}</small>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="closeForm()"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="isLoadingSave"
              @click="saveItem()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "@/mixins/validationRules";

export default {
  mixins: [validationRules],
  props: {
    filterOptions: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isVisibleDialog: false,
      isLoadingSave: false,
      options: {},
      emails: [""],

      //
      alertTypeOpt: [
        {
          id: "charger_connectivity",
          name: "Charger On/Off",
        },
        {
          id: "charger_error",
          name: "Charger Errors",
        },
      ],
      durationLists: [
        {
          id: "6",
          name: "6 Hours",
        },
        {
          id: "12",
          name: "12 Hours",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsCSO: "tenantsManagement/getTenantsCSO",
    }),
    tenantsByProduct() {
      if (this.options?.product) {
        if (this.options.product == "oem") {
          return this.tenantsOEM;
        } else {
          return this.tenantsCSO;
        }
      } else {
        return [];
      }
    },
  },

  watch: {
    // add any required watchers here
    "options.alert_type": {
      handler: function () {
        delete this.options.trigger_after_seconds;
      },
    },
  },

  // async mounted() {
  // if (this.authUser.isAdmin) {
  // await this.$store.dispatch("meta/getClients", "tenant");
  // }
  // },

  methods: {
    openModal() {
      this.isVisibleDialog = !this.isVisibleDialog;
    },
    closeForm() {
      this.$refs.form.reset();

      this.isVisibleDialog = false;
    },
    async saveItem() {
      if (this.$refs.form.validate()) {
        this.isLoadingSave = true;
        let params = { ...this.options, recipient_emails: this.emails };
        await this.$store
          .dispatch("csmsChargingDiagnostics/setEmailAlerts", params)
          .then(() => {
            this.$store.dispatch(
              "alerts/success",
              this.$t("created_successfully")
            );
            this.closeForm();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
            this.isLoadingSave = false;
          })
          .finally(() => (this.isLoadingSave = false));
      }
    },
  },
};
</script>
